import Hoverable from '@omni/kit/components/Hoverable';
import KitBadge from '@omni/kit/components/KitBadge';
import KitFadeView from '@omni/kit/components/KitFadeView';
import Tooltip, { TooltipProps } from '@omni/kit/components/Tooltip';
import Spacing from '@omni/kit/theming/Spacing';
import React, { ReactElement, useEffect, useState } from 'react';
import { Pressable, StyleProp, StyleSheet, ViewStyle } from 'react-native';

interface LiveTagProps {
  isVisible: boolean;
  style?: StyleProp<ViewStyle>;
  onPress?: () => void;
  isLive?: boolean;
  isClickable?: boolean;
  tooltipProps?: Omit<TooltipProps, 'children'>;
}

export default function LiveTag({
  isVisible = true,
  style,
  onPress,
  isLive = true,
  isClickable = true,
  tooltipProps,
}: LiveTagProps): ReactElement {
  const [isHovering, setIsHovering] = useState(false);
  const [isPressing, setIsPressing] = useState(false);

  const liveTagButton = (
    <KitFadeView
      show={isVisible}
      style={[
        styles.container,
        isHovering && isClickable && styles.scaleUp,
        isPressing && isClickable && styles.scaleDown,
        style,
      ]}
    >
      <Hoverable
        onHoverIn={() => {
          setIsHovering(true);
        }}
        onHoverOut={() => {
          setIsHovering(false);
        }}
      >
        <Pressable
          onPress={onPress}
          onPressIn={() => {
            setIsPressing(true);
          }}
          onPressOut={() => {
            setIsPressing(false);
          }}
          pointerEvents={isClickable ? 'auto' : 'none'}
        >
          <KitBadge text='Live' color={isLive ? 'live' : 'default'} size='l' />
        </Pressable>
      </Hoverable>
    </KitFadeView>
  );

  return tooltipProps?.label && !isLive ? (
    <Tooltip keepTooltipInside={true} {...tooltipProps}>
      {liveTagButton}
    </Tooltip>
  ) : (
    liveTagButton
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: 20,
    margin: Spacing.m,
  },
  scaleDown: {
    transform: [{ scale: 0.98 }],
  },
  scaleUp: {
    transform: [{ scale: 1.02 }],
  },
});
